import { appRoleSets, appRoleSetTypes } from 'services/Auth/appRoles';
import { IdentityProviderType } from 'models/identity/identityProvider';
import Login from 'models/identity/login';
import Tenant from 'models/tenants/tenant';
import User from 'models/users/user';
import UserLanguage from 'models/users/userLanguage';

export default class CurrentUser extends User {
  language: UserLanguage; //the current language of the user in the application

  tenant: Tenant; //the tenant of the session

  login: Login;

  constructor(id: string, tenant: Tenant, displayName: string, email: string, language: string) {
    super(id, email, displayName); //the SkillControl user id

    this.tenant = tenant;
    this.name = displayName;
    this.email = email;
    this.language = new UserLanguage(language);
    this.login = new Login();
  }

  static getEmptyUser() {
    return new CurrentUser('', new Tenant('', ''), '', '', '');
  }

  clone(): CurrentUser {
    const newUser = new CurrentUser(this.id, this.tenant, this.name, this.email, this.language.code);
    newUser.created = this.created;
    newUser.lastLogin = this.lastLogin;
    newUser.hasLicense = this.hasLicense;
    newUser.photo = this.photo?.slice();
    newUser.photoURL = this.photoURL;
    newUser.identityProviderType = this.identityProviderType;
    newUser.providerUserId = this.providerUserId;
    newUser.login = this.login;
    newUser.language = this.language.clone();
    newUser.tenant = this.tenant.clone();

    return newUser;
  }

  override isAdmin = (): boolean => {
    const sr = this.login.userSystemRoles ?? [];

    return sr.some((role) => appRoleSets[appRoleSetTypes.Admins].includes(role));
  };

  override hasPaidLicense = (): boolean => {
    const sr = this.login.userSystemRoles ?? [];

    return sr.some((role) => appRoleSets[appRoleSetTypes.Licensed].includes(role));
  };

  //the account page of the identity provider the user signed in with; empty when the provider has none
  getMyAccountURL() {
    switch (this.login.identityProviderType) {
      case IdentityProviderType.Google:
        return `https://myaccount.google.com/`;
      case IdentityProviderType.Oidc:
        return '';
      default:
        return `https://myaccount.microsoft.com/`;
    }
  }
}
